import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Paper } from '@mui/material';
import { HeadlinePage, SearchBarBox, TableCustom } from 'components/common';
import { withPermission } from 'hoc';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';


const TemplateListDumb = ({
  handleSearch,
  handleCreate,
  handleEdit,
  handleView,
  handleDelete,
  handleRunJob,
  content,
  options,
  isLoaded,
  defaultValues,
  validPermission,
  searchValue
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues("project");
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (workflow) => {
    handleDelete(workflow);
  };

  const onEdit = (workflow) => {
    handleEdit(workflow);
  };

  const onView = (workflow) => {
    handleView(workflow);
  }

  const onRunJob = (workflow) => {
    handleRunJob(workflow);
  };

  const columns = [
    { label: t('common.components.table.col.name'), key: 'name' },
    { label: t('common.components.table.col.description'), key: 'description' },
  ];

  const createActions = () => {
    const actions = [];
    const isEdit =  (validPermission(projectId, 'isEdit'));

    if (validPermission(projectId, 'isExecute')) actions.push({
      label: t('templateList.components.table.run'),
      icon: <PlayCircleOutlineOutlinedIcon color='primary' />,
      handle: onRunJob
    })
    if (validPermission(projectId, 'isEdit')) actions.push({
      label: t('templateList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit
    })

    if (validPermission(projectId, 'isVisible')) actions.push({
      label: t('common.components.buttons.view'),
      icon: <VisibilityOutlinedIcon color="primary" />,
      handle: onView
    })

    if (validPermission(projectId, 'isDelete')) actions.push({
      label: t('templateList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    })

    return actions;
  }

  const actions = createActions();

  return (
    <>
      <HeadlinePage
        title="templateList.headline"
        buttonLabel={validPermission(projectId, "isCreate") ? "templateList.components.add" : ""}
        handleOnClick={handleCreate}
      />
      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        options={options}
        searchValue={searchValue}
      />
      <Paper sx={{ p: 2}}>
        <TableCustom
          title='templateList.components.titleList'
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  );
};

export default withPermission(TemplateListDumb, "templates");
